var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"w-full h-[100vh] bg-white overflow-y-auto",attrs:{"id":"TroubleshootCalendar"}})])}]

export { render, staticRenderFns }